import styled from '@emotion/styled';

import { FontFamily, FontSize, FontWeight, LineHeight } from '../../styling/AppStyles';

/**
 * A convenience component to style a paragraph (or other) with some of the
 * predetermined paramters from (Figma) design system.
 *
 * If you need to use this often, consider creating a new component for that
 * specific text style.
 *
 * Defaults to inheriting font family, weight, etc. from an ancestor -- usually a style
 * matching Figma "Desktop/Body Text Large Bold", see also <AppStyles />
 */
const ExinText = styled.p<{
  size?: FontSize;
  family?: FontFamily;
  weight?: FontWeight;
  height?: LineHeight;
}>`
  font-family: ${({ family = 'inherit' }) => family};
  font-weight: ${({ weight = 'inherit' }) => weight};
  font-size: ${({ size = 'inherit' }) => size};
  line-height: ${({ height = 'inherit' }) => height};
`;

export default ExinText;

// Several preset variations of ExinText. The match the steno used in Figma;

/**
 * Matches Figma "Desktop/H1"
 */
export const ExinH1Text = styled.h1`
  font-family: ${FontFamily.special};
  font-weight: ${FontWeight.bolder};

  font-size: 30px;
  line-height: 42px;
  @media (min-width: 600px) {
    font-size: ${FontSize.largest};
    line-height: ${LineHeight.small};
  }
`;

/**
 * Matches Figma "Desktop/H2"
 */
export const ExinH2Text = styled.h2`
  font-family: ${FontFamily.special};
  font-weight: ${FontWeight.bold};

  font-size: 27px;
  line-height: 38px;
  @media (min-width: 600px) {
    font-size: ${FontSize.larger};
    line-height: ${LineHeight.large};
  }
`;

/**
 * Matches Figma "Desktop/H3"
 */
export const ExinH3Text = styled.p`
  font-family: ${FontFamily.special};
  font-weight: ${FontWeight.bold};
  font-size: ${FontSize.large};
  line-height: ${LineHeight.small};
`;

/**
 * Matches Figma "Desktop/Body Text Normal"
 */
export const ExinSmallText = styled.p`
  font-size: ${FontSize.small};
  font-weight: ${FontWeight.thin};
`;

/**
 * Matches Figma "Desktop/Caption Text Bold"
 */
export const ExinCaptionText = styled.p`
  font-size: ${FontSize.smallest};
  font-weight: ${FontWeight.normal};
  margin: 1em 0;
`;
